import Headline from '../../../../components/Headline';
import Description from '../../../../components/Description';
import { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { selectProduct } from '../../../../../../../store/selectors/products';

const Details = () => {
  const { data } = useSelector(selectProduct);
  const { content } = data;

  return (
    <Fragment>
      <Headline message='Integration details' />

      <Description message={content.description} />
    </Fragment>
  );
};

export default Details;
